import { Avatar } from '@lingoda/ui';
import { useHeaderAvatarQuery } from '@lingoda/graphql';
import { styled } from '@lingoda/ui/theme';

interface HeaderAvatarProps {
    onClick?: () => void;
}

export const HeaderAvatar = ({ onClick }: HeaderAvatarProps) => {
    const { data } = useHeaderAvatarQuery();

    return (
        <AvatarStyled
            onClick={onClick}
            size={40}
            src={data?.currentUser?.photo?.urls.thumbnail_large}
            data-cy="header-user-avatar"
        >
            {data?.currentUser?.firstname}
        </AvatarStyled>
    );
};

const AvatarStyled = styled(Avatar)({
    '&:hover': {
        filter: 'brightness(90%)',
    },
});
